import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

// 選手番号でコメントを検索する関数（選手名での検索は廃止）
export const searchRacerComments = async (searchTerm) => {
  try {
    // 選手番号のみでリクエストを行う
    const searchParam = { racer_number: searchTerm };
    
    // APIGWのエンドポイントを呼び出す
    const response = await axios.post(`${API_BASE_URL}racers/comments`, searchParam);
    
    // レスポンスには racer_info, comments, count が含まれる
    return {
      racerInfo: response.data.racer_info,
      comments: response.data.comments || [],
      count: response.data.count || 0
    };
  } catch (error) {
    console.error('API Error:', error);
    throw new Error(`選手のコメント情報の取得に失敗しました: ${error.message}`);
  }
};
